import Link from "next/link";

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center mr-3">
                <span className="text-white font-bold">Z</span>
              </div>
              <h3 className="text-xl font-bold">Zak - Ferrailleur Épaviste Saint-Étienne</h3>
            </div>
            <p className="text-gray-300 mb-4">
              Ferrailleur – Épaviste à Saint-Étienne depuis 2010. Spécialiste de l'enlèvement gratuit de véhicules et du rachat de
              métaux (cuivre, laiton, aluminium) dans la Loire, la Haute-Loire et le Rhône.
            </p>
            <p className="text-gray-300">Ferrailleur épaviste établi à Saint-Étienne depuis 2010</p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              {["Accueil", "À propos", "Tarifs", "Fonctionnement", "Contact"].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase().replace("à ", "")}`}
                    className="text-gray-300 hover:text-green-500 transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services d'Épaviste et Ferrailleur</h4>
            <ul className="space-y-2">
              {[
                "Épaviste Saint-Étienne - enlèvement gratuit",
                "Ferrailleur Loire et Haute-Loire",
                "Rachat de métaux (cuivre, laiton, alu)",
                "Rachat de ferraille à Saint-Étienne",
                "Service pour particuliers et professionnels",
                "Intervention Loire, Haute-Loire, Rhône",
              ].map((item, index) => (
                <li key={index}>
                  <a href="#contact" className="text-gray-300 hover:text-green-500 transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Épaviste Saint-Étienne</h4>
            <address className="text-gray-300 not-italic">
              <p className="mb-2">Tél : <a href="tel:+33614868693" className="hover:text-green-500">+33 6 14 86 86 93</a></p>
              <p className="mb-2">Email : <a href="mailto:contact@zak-ferrailleur.fr" className="hover:text-green-500">contact@zak-ferrailleur.fr</a></p>
              <p className="mb-2">Zone : Saint-Étienne, Loire (42), Haute-Loire (43), Rhône (69)</p>
            </address>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/194F5j2KNu/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook Zak Ferrailleur Épaviste Saint-Étienne"
                className="text-gray-300 hover:text-green-500 transition-colors"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54v-2.203c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <hr className="border-gray-700 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 mb-4 md:mb-0">
            &copy; {currentYear} Zak - Ferrailleur Épaviste Saint-Étienne. Tous droits réservés.
          </p>
          <div className="flex space-x-6">
            <Link href="/mentions-legales" className="text-gray-300 hover:text-green-500 transition-colors">
              Mentions légales
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
